import React, { useState, useEffect } from "react";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

function EmailUser({ email: emailParam }) {
  const [init, setInit] = useState(false);
  const [messageEmail, setMessageEmail] = useState();
  const [checkEmail, setCheckEmail] = useState(false);
  const [email, setEmail] = useState(emailParam);
  const [showFormEditEmail, setShowFormEditEmail] = useState(false);

  useEffect(() => {
    checkEmailUserConfirm().then(() => {
      setInit(true);
    });
  }, []);

  let messageEmailTag;
  if (messageEmail) {
    messageEmailTag = (
      <div className={`${messageEmail.type_class}`}>
        <i className={`${messageEmail.class_icon} pl-2`}></i>
        <span>{messageEmail.text}</span>
      </div>
    );
  }
  const sendEmailConfirm = async () => {
    const headersRequest = getHeaderRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/send-verification-email",
        headersRequest
      );
    } catch (error) {
      setMessageEmail({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle pl-2 ",
      });
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    setMessageEmail({
      type_class: "alert alert-success ",
      text: result.data.message,
      class_icon: "fa fa-exclamation-triangle pl-2 ",
    });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const checkEmailUserConfirm = async () => {
    setCheckEmail(await sendRequestCheckEmailUserConfirm());
  };

  const sendRequestCheckEmailUserConfirm = async () => {
    const headersRequest = getHeaderRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/check-email-confirm",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    return result.data.data;
  };

  const editEmail = async () => {
    const email = document.querySelector("#email").value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestEditEmail = await sendRequestEditEmail(email);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestEditEmail) {
      return;
    }
    setEmail(email);
    setMessageEmail({
      type_class: "alert alert-success",
      text: "ایمیل شما ویرایش شد.جهت تایید ایمیل خود روی دکمه زیر کلیک نمائید.",
      class_icon: "fa fa-exclamation-triangle pl-2 ",
    });
    setCheckEmail(false);
    document.querySelector("#email").value = "";
    document.querySelector(".hr-title-page").scrollIntoView();
  };

  const sendRequestEditEmail = async (email) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/edit-email",
        { email: email },
        headersRequest
      );
    } catch (error) {
      setMessageEmail({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle pl-2 ",
      });
      return false;
    }

    return true;
  };

  const showEditEmailUserForm = () => {
    return (
      <div>
        <hr />
        <div>
          جهت ویرایش ایمیل , ایمیل خود را وارد کرده و روی دکمه ویرایش کلیک کنید.
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            editEmail();
          }}
          className="d-flex pt-2"
        >
          <div>
            <input
              placeholder="ایمیل جدید"
              className="form-control"
              type="email"
              id="email"
              required
            />
          </div>
          <div className="pr-2">
            <button className="btn btn-success">ویرایش</button>
          </div>
        </form>
      </div>
    );
  };

  const checkStatusEmailUser = () => {
    return (
      <>
        {checkEmail == true ? (
          <div className="pt-3 d-flex align-items-center  ">
            <span className="pl-2">
              <p className="m-0">ایمیل شما با موفقیت تایید شد.</p>
            </span>
            <span
              className="btn btn-primary"
              onClick={() => {
                setShowFormEditEmail(true);
              }}
            >
              ویرایش ایمیل
            </span>
          </div>
        ) : (
          <>
            <div className="pt-3">
              <p className="m-0">
                جهت تایید ایمیل خود روی دکمه زیر کلیک نمائید.
              </p>
            </div>
            <div className="pt-3 text-center">
              <span>
                <button className="btn btn-success" onClick={sendEmailConfirm}>
                  ارسال ایمیل تایید
                </button>
              </span>
              <span className="pr-2">
                <span
                  className="btn btn-primary"
                  onClick={() => {
                    setShowFormEditEmail(true);
                  }}
                >
                  ویرایش ایمیل
                </span>
              </span>
            </div>
          </>
        )}
        {showFormEditEmail && showEditEmailUserForm()}
      </>
    );
  };

  return (
    <>
      <section className="content" id="user-email-box">
        <div className="card">
          <div className="card-body">
            {messageEmailTag}
            {checkEmail == false ? (
              <div className="alert alert-warning ">
                <i className="fa fa-exclamation-triangle pl-2 "></i>
                <span>
                  شما هنوز ایمیل خود را تایید نکرده اید.لطفا ایمیل خود را تایید
                  کنید.
                </span>
              </div>
            ) : (
              <></>
            )}
            <div className="d-flex flex-row">
              <div className="pl-2">
                <span>
                  {checkEmail == true ? (
                    <i className="fas fa-check-circle text-success"></i>
                  ) : (
                    <i className="fas fa-times-circle text-warning"></i>
                  )}
                </span>
              </div>
              <div className="w-100">
                <div>
                  <p className="m-0">کاربر محترم </p>
                </div>
                <div className="pt-3">
                  <span>ایمیل : </span>
                  <span>{email}</span>
                </div>
                {init == true ? checkStatusEmailUser() : <></>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EmailUser;
